function parseDateTime(timestamp,formats){
    // formats格式包括
    // 1. yyyy-MM-dd
    // 2. yyyy-MM-dd HH:mm:ss
    // 3. Y年m月d日
    // 4. Y年m月d日 H时i分
    // 5. yyyy-QQQ,yyyy,yyyy-MM 目前先兼容为 yyyy-MM-dd
    formats = formats || 'yyyy-MM-dd';
    var zero = function (value) {
        if (value < 10) {
            return '0' + value;
        }
        return value;
    };

    var myDate = timestamp? new Date(timestamp): new Date();

    var year = myDate.getFullYear();
    var month = zero(myDate.getMonth() + 1);
    var day = zero(myDate.getDate());

    var hour = zero(myDate.getHours());
    var minite = zero(myDate.getMinutes());
    var second = zero(myDate.getSeconds());
    if(formats == 'yyyy' || formats == 'yyyy-MM' || formats == 'yyyy-QQQ') {
        return year+ '-' +month+ '-' +day;
    }

    return formats.replace(/yyyy|MM|dd|HH|mm|ss/ig, function (matches) {
        return ({
            yyyy: year,
            MM: month,
            dd: day,
            HH: hour,
            mm: minite,
            ss: second
        })[matches];
    });
  }
  export default parseDateTime


// WEBPACK FOOTER //
// ./src/form/moment.js